export const GET_CLIENT_SECRETS = 'GET_CLIENT_SECRETS'
export const DELETE_CLIENT_SECRETS = 'DELETE_CLIENT_SECRETS'
export const CREATE_CLIENT_SECRETS = 'CREATE_CLIENT_SECRETS'
export const SHOW_CLIENT_SECRETS = 'SHOW_CLIENT_SECRETS'
export const UPDATE_CLIENT_SECRETS = 'UPDATE_CLIENT_SECRETS'
